// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verify-mfa-page .mdhd-checkbox-field .mdhd-checkbox-input {
    appearance: auto;
}
.verify-mfa-page {
    display: flex;
    flex-direction: column;
}
.verify-mfa-page .mfa-section {
    display: flex;
    flex-direction: column;
}
.verify-mfa-page .mfa-section p {
    padding: 0 0 2px 0;
}
.verify-mfa-page .mfa-section button {
    margin-top: 4px;
}
.verify-mfa-page h4 {
    font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Coordinator/VerifyMfa.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB","sourcesContent":[".verify-mfa-page .mdhd-checkbox-field .mdhd-checkbox-input {\n    appearance: auto;\n}\n.verify-mfa-page {\n    display: flex;\n    flex-direction: column;\n}\n.verify-mfa-page .mfa-section {\n    display: flex;\n    flex-direction: column;\n}\n.verify-mfa-page .mfa-section p {\n    padding: 0 0 2px 0;\n}\n.verify-mfa-page .mfa-section button {\n    margin-top: 4px;\n}\n.verify-mfa-page h4 {\n    font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
